/**
 * public routes
 * @type {string[]}
 */
export const publicRoutes = [
    "/images/login/avatar.png",
    "/layout/images/logo/logo-dark.png",
    "/layout/images/logo/logo-white.png",
    "/images/logo/logo-dark.png",
    "/images/logo/logo-white.png",
    "/themes/bootstrap4-light-blue/theme.css",
    "/themes/bootstrap4-dark-blue/theme.css",
    "/images/tws2white.png"
]

/**
 * uses for authtentication
 * @type {string[]}
 */
export const authRoutes = [
    "/auth/login", "/auth/register"
]

/**
 * the prefix form api autehnttication routes
 * routes that start with the prefix are use form api
 * @type {string}
 */
export const apiAuthPrefix = "/api/auth"

/**
 * RUTA 
 * 
 * @type {string}
 */
export const DEFAULT_LOGIN_REDIRECT = "/"

/**
 * RUTA 
 * 
 * @type {string}
 */
export const DESFAULT_UNAUTHORIZED_REDIRECT = "/"

